/**
 * DataLayer utilities for GA4 e-commerce tracking
 * 
 */

// Track pushed transactions to prevent duplicates within session
const pushedTransactions = new Set();

// SessionStorage key for persisting across page refreshes
const STORAGE_KEY = 'idp_pushed_transactions';

/**
 * Check if a transaction has already been pushed (in-memory or sessionStorage)
 */
const hasTransactionBeenPushed = transactionId => {
  // Check in-memory first
  if (pushedTransactions.has(transactionId)) {
    return true;
  }

  // Check sessionStorage for page refresh scenarios
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const storedIds = JSON.parse(stored);
      if (storedIds.includes(transactionId)) {
        // Sync to in-memory set
        pushedTransactions.add(transactionId);
        return true;
      }
    }
  } catch (e) {
    // sessionStorage not available or parse error
  }
  return false;
};

/**
 * Mark a transaction as pushed (in-memory and sessionStorage)
 */
const markTransactionAsPushed = transactionId => {
  pushedTransactions.add(transactionId);
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const storedIds = stored ? JSON.parse(stored) : [];
    if (!storedIds.includes(transactionId)) {
      storedIds.push(transactionId);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(storedIds));
    }
  } catch (e) {
    // sessionStorage not available or parse error
  }
};
/**
 * Push purchase event to dataLayer - guaranteed single push per transaction
 */
export const pushPurchaseEvent = data => {
  // Prevent duplicate pushes
  if (hasTransactionBeenPushed(data.transaction_id)) {
    return false;
  }
  window.dataLayer = window.dataLayer || [];

  // Clear previous ecommerce data
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: data.transaction_id,
      value: data.value,
      currency: 'AUD',
      items: [{
        item_id: 'IDP',
        item_name: 'International Driving Permit',
        item_category: 'Travel Documents',
        price: data.value,
        quantity: 1
      }]
    },
    club: data.club,
    delivery_method: data.delivery_method
  });
  markTransactionAsPushed(data.transaction_id);
  return true;
};